module.exports = __webpack_public_path__ + "img/bb_g3_t_ears-04.bd00702e.svg";